import { formatDate } from "@/app/AlertsDashboard/utils";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Spinner } from "@/components/ui/spinner";
import { Table, TableBody, TableCaption, TableCell, TableFooter, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ExternalConnectionIndexed } from "@/hooks/externalConnectionsApi";
import { ConnectedDeviceFilter, ExternalConnectionDto } from "@/lib/integrationTypes/externalConnectionTypes";
import { IntegrationFullDto, IntegrationLimitedDto } from "@/lib/integrationTypes/integrationTypes";
import { createHumanList } from "@/lib/utils";
import { plural } from "@/lib/utils/pluralize";
import { formatDistanceToNow, formatISO } from "date-fns";
import { useMemo } from "react";

export interface ConnectionDataProps {
    loading: boolean;
    connectionData: ExternalConnectionIndexed | ExternalConnectionDto | undefined;
    integration: IntegrationLimitedDto,
    dataDate: Date
}

type ConnectionKeyAggregator = {
    options: string[]
} & ConnectedDeviceFilter;

export default function ConnectionData({ connectionData, loading, integration, dataDate }: ConnectionDataProps) {

    const noData = !connectionData || !connectionData.deviceCreationKeyValues || !connectionData.deviceCreationChoices;

    const deviceOptionsByKey: ConnectionKeyAggregator[] = useMemo(() => {
        if (!connectionData || !connectionData.deviceCreationKeyValues || !connectionData.deviceCreationChoices) {
            return [];
        }
        console.log(connectionData)

        let keyAggregator = connectionData.deviceCreationKeyValues.map((filter) => {
            return {
                ...filter,
                options: [...new Set(
                    connectionData.deviceCreationChoices.map((choice) => choice[filter.key])
                )]
            }
        })

        return keyAggregator
    }, [connectionData])


    if (!loading && !connectionData) {
        return <></>;
    }

    return <>
        <section className="mt-6 rounded-xl border bg-[#111]">
            <div className="flex justify-between items-center p-6">
                <h2 className="text-xl font-semibold">{loading ? `Connecting to ${integration.name}...` : `Connected to ${integration.name}`}</h2>
                <Badge variant={"secondary"}>{isNaN(dataDate.valueOf()) || dataDate.valueOf() == 0 ? "Never" : formatDate(dataDate)}</Badge>
            </div>
            <ScrollArea className={`${(noData || deviceOptionsByKey.length == 0) ? "" : "h-72"} p-6 border-t-2`}>
                {(loading ? <Spinner /> : (
                    (noData || deviceOptionsByKey.length == 0) ? (
                        <div className="flex justify-center items-center h-full">
                            <p className="text-lg text-center">Connection has not been indexed.</p>
                        </div>
                    ) : (
                        <div>
                            <p>
                                Discovered {createHumanList(deviceOptionsByKey.map(key => `${key.options.length} ${plural(key.displayName, key.options.length)}`))}.
                            </p>
                            <Table >
                                <TableCaption>A list of the data pulled from the External Connection.</TableCaption>
                                <TableHeader>
                                    <TableRow>
                                        <TableCell className="pr-0 w-8 font-bold text-gray">#</TableCell>
                                        {connectionData?.deviceCreationKeyValues?.map((key, i) => (
                                            <TableCell className="font-bold" key={i}>{key.displayName}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {connectionData?.deviceCreationChoices?.map((choice, i) => (
                                        <TableRow key={i} >
                                            <TableCell className="pr-0 w-8 text-gray">{i + 1}</TableCell>
                                            {connectionData?.deviceCreationKeyValues?.map((key) => (
                                                <TableCell className="font-medium">{choice[key.key]}</TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    )
                )
                )}
            </ScrollArea>
        </section>
    </>

}